export function isOrderBalProduct(productName) {
    return !!productName && productName.toLowerCase().includes('bal');
}
export function isOrderPlasmaProduct(productName) {
    return !isOrderBalProduct(productName);
}
